import { z } from 'zod';
import { IsoInstantSchema, PageQuerySchema } from './common.js';
import { NotificationChannelSchema, NotificationStatusSchema } from './enums.js';
export const NotificationLogSchema = z.object({
    id: z.number().int().positive(),
    reservationId: z.string().uuid().nullable(),
    channel: NotificationChannelSchema,
    template: z.string(),
    payload: z.unknown(),
    status: NotificationStatusSchema,
    attempts: z.number().int().nonnegative(),
    lastError: z.string().nullable(),
    createdAt: IsoInstantSchema,
});
export const NotificationListQuerySchema = PageQuerySchema.extend({
    reservationId: z.string().uuid().optional(),
    status: NotificationStatusSchema.optional(),
});
export const NotificationHealthSchema = z.object({
    total: z.number().int().nonnegative(),
    sent: z.number().int().nonnegative(),
    failed: z.number().int().nonnegative(),
    retry: z.number().int().nonnegative(),
    failureRatePct: z.number().min(0).max(100),
    circuitState: z.enum(['CLOSED', 'OPEN', 'HALF_OPEN']),
    lastErrorAt: IsoInstantSchema.nullable(),
});
//# sourceMappingURL=notification.dto.js.map